var SearchFormEquipment = (function(){
  'use strict';

  var error = function(msg) {
    $('#geolocation-status').addClass('error');
    $('#geolocation-status').html(typeof msg === 'string' ? msg : "Echec de la géolocalisation !");
    $('#geolocation-status').removeClass('geolocating');
    $('#autour').prop('checked', false);
    $("#geolocation-status").removeClass('hide');

    // Empty lat/lng
    $('#geolocation-lat').val('');
    $('#geolocation-lng').val('');
  };

  var success = function(position) {

    var boundLatNorth = 45.39;
    var boundLatSouth = 46.14;
    var boundLatWest = 4.39;
    var boundLatEast = 5.43;

    if(position.coords.latitude < boundLatSouth && position.coords.latitude > boundLatNorth && position.coords.longitude < boundLatEast && position.coords.longitude > boundLatWest){
      $('#geolocation-lat').val(position.coords.latitude);
      $('#geolocation-lng').val(position.coords.longitude);
      $('#geolocation-status').html('');
      $('#geolocation-status').removeClass('geolocating');
      $("#geolocation-status").removeClass('hide');
    }
    else {
      error('Vous êtes en dehors de la zone de couverture !');
    }
  };


  return {
    init: function() {

      $('#autour').on('click', function() {

        // Empty lat/lng
        $('#geolocation-lat').val('');
        $('#geolocation-lng').val('');

        if($(this).is(":checked")) {
          $('#geolocation-status').removeClass('hide');
          $('#geolocation-status').removeClass('error');
          $('#geolocation-status').addClass('geolocating');
          $('#geolocation-status').html('<span class="icon spinner"></span> Géolocalisation en cours...');

          if (navigator.geolocation) {
              navigator.geolocation.getCurrentPosition(success, error);
          }
          else {
            error('Votre navigateur ne supporte pas la géolocalisation !');
          }
        }
        else {
          $('#geolocation-status').html('');
        }
      });
    }
  };

}());

$(document).ready(function(){
  SearchFormEquipment.init();
});
